<template>
   <v-snackbar
      :timeout="-1"
      :value="true"
      absolute
      centered
      color="orange accent-4"
      elevation="24"
      v-model="snackbar"
      :multi-line="multiLine"
    >
      <span v-for="(item, i) in text" :key="i">{{ item }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="clearMsg"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
      multiLine: true,
      snackbar: false,
      text: [],
    }),
  computed: {
    ...mapGetters({
      messages: "gMessages"
    })
  },
  watch: {
    /* messages() {
      if (this.messages.length) {
        this.text = this.messages;
        this.snackbar = true;
      }
    } */
  },
  methods: {
    clearMsg() {
      this.snackbar = false;
      this.$store.commit("mClearMessage");
    }
  }
}
</script>

<style>

</style>